<template>
  <BaseNewForm>
      <template v-slot:header>
        {{ getTitle }}
      </template>
      <div class="quote">
        <slot></slot>
      </div>
  </BaseNewForm>
</template>

<script>
import BaseNewForm from '../BaseNewForm'
export default {
  name: 'BaseNewQuote',
  props: {
    title: {
      type: String,
      required: false
    }
  },
  components: {
    BaseNewForm
  },
  computed: {
    getTitle () {
      if (this.title) {
        return this.title
      } else {
        return this.$t('qic_quote_header')
      }
    }
  }
}
</script>
